// PolitiqueCookies.jsx
// ———————————————————————————————————————————————————————————
// Page Politique de cookies (sans implémentation du bandeau)
// Remplacer les [CHAMPS] puis router vers /politique-de-cookies
// ———————————————————————————————————————————————————————————

import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Link as MuiLink,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";

function LegalLayout({ title, subtitle, children }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 5, md: 6 },
          backgroundColor: "#F8F8F8",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <Typography
          gutterBottom
          sx={{
            color: "#000",
            fontWeight: 900,
            fontSize: { xs: "2.2rem", md: "3rem" },
            lineHeight: 1.2,
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ color: "#444", fontWeight: 500, fontSize: "1.1rem", mb: 3 }}>
            {subtitle}
          </Typography>
        )}
        <Divider sx={{ mb: 4 }} />
        {children}
      </Paper>
    </Box>
  );
}

function SectionTitle({ children }) {
  return (
    <Typography sx={{ fontWeight: 800, fontSize: { xs: "1.35rem", md: "1.55rem" }, color: "#000", mt: 3, mb: 1 }}>
      {children}
    </Typography>
  );
}

function Paragraph({ children }) {
  return (
    <Typography sx={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7, mb: 2 }}>
      {children}
    </Typography>
  );
}

export default function PolitiqueCookies() {
  const openPreferences = () => {
    // Ouvre le gestionnaire quand il sera implémenté
    window.dispatchEvent(new Event("open-cookie-preferences"));
  };

  return (
    <>
      <Navbar />
      <Box sx={{ height: "50px" }} />
        <LegalLayout
        title={<><span>Politique de </span><Box component="span" sx={{ color: "#449F2D" }}>cookies</Box></>}
        subtitle="Fonctionnement des cookies/traceurs, catégories utilisées et gestion du consentement."
        >
        <Paragraph>Dernière mise à jour : [JJ mois AAAA]</Paragraph>

        <SectionTitle>Qu’est-ce qu’un cookie ?</SectionTitle>
        <Paragraph>
            Un cookie (ou traceur similaire : local storage, pixel, SDK) est un identifiant déposé ou lu
            sur votre terminal lors de la navigation. Il peut collecter des informations sur l’usage du Site.
        </Paragraph>

        <SectionTitle>Qui dépose les cookies ?</SectionTitle>
        <Paragraph>
            • <strong>Cookies internes</strong> : déposés par [Safe for Bike].<br />
            • <strong>Cookies tiers</strong> : déposés par nos partenaires (ex. analytics, carte, publicité).
        </Paragraph>

        <SectionTitle>Votre consentement</SectionTitle>
        <Paragraph>
            Les cookies non essentiels ne sont déposés qu’avec votre <strong>consentement préalable</strong>.
            Vous pouvez refuser aussi facilement qu’accepter et retirer votre consentement à tout moment :
        </Paragraph>
        <Button
            onClick={openPreferences}
            variant="contained"
            sx={{
            backgroundColor: "#449F2D",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            borderRadius: "999px",
            px: 3,
            py: 1,
            "&:hover": { backgroundColor: "#3A8C27" },
            mb: 1.5,
            }}
        >
            Gérer mes cookies
        </Button>

        <SectionTitle>Catégories de cookies</SectionTitle>
        <Paragraph>
            • <strong>Strictement nécessaires</strong> (exemptés) : fonctionnement, sécurité, session, choix de langue.<br />
            • <strong>Mesure d’audience</strong> : statistiques de fréquentation (consentement si non exemptés).<br />
            • <strong>Fonctionnels</strong> : confort d’usage, personnalisation.<br />
            • <strong>Publicité & réseaux sociaux</strong> : personnalisation publicitaire, partage social.
        </Paragraph>

        <SectionTitle>Durées indicatives</SectionTitle>
        <Paragraph>
            Nécessaires : session à 12 mois • Audience/Fonctionnels/Publicité : jusqu’à 13 mois •
            Conservation du choix de consentement : ~6 mois.
        </Paragraph>

        <SectionTitle>Liste indicative (à personnaliser selon vos outils)</SectionTitle>
        <Table sx={{ mb: 2 }}>
            <TableHead>
            <TableRow>
                <TableCell><strong>Catégorie</strong></TableCell>
                <TableCell><strong>Émetteur</strong></TableCell>
                <TableCell><strong>Nom</strong></TableCell>
                <TableCell><strong>Finalité</strong></TableCell>
                <TableCell><strong>Durée</strong></TableCell>
                <TableCell><strong>Consentement</strong></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            <TableRow>
                <TableCell>Nécessaire</TableCell>
                <TableCell>Interne</TableCell>
                <TableCell>session_id</TableCell>
                <TableCell>Maintien de la session</TableCell>
                <TableCell>Session</TableCell>
                <TableCell>Non</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Nécessaire</TableCell>
                <TableCell>Interne</TableCell>
                <TableCell>cookie_consent</TableCell>
                <TableCell>Mémoriser vos choix</TableCell>
                <TableCell>6 mois</TableCell>
                <TableCell>Non</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Audience</TableCell>
                <TableCell>[Matomo/GA]</TableCell>
                <TableCell>_pk_id / _ga</TableCell>
                <TableCell>Statistiques</TableCell>
                <TableCell>13 mois</TableCell>
                <TableCell>Oui/Parfois</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Fonctionnel</TableCell>
                <TableCell>Leaflet / OSM</TableCell>
                <TableCell>osm*</TableCell>
                <TableCell>Carte partenaires</TableCell>
                <TableCell>Variable</TableCell>
                <TableCell>Oui</TableCell>
            </TableRow>
            <TableRow>
                <TableCell>Publicité</TableCell>
                <TableCell>[Réseau]</TableCell>
                <TableCell>__ad*</TableCell>
                <TableCell>Publicité ciblée</TableCell>
                <TableCell>6–13 mois</TableCell>
                <TableCell>Oui</TableCell>
            </TableRow>
            </TableBody>
        </Table>

        <SectionTitle>Plus d’informations</SectionTitle>
        <Paragraph>
            Consultez <MuiLink href="/politique-de-confidentialite">la Politique de confidentialité</MuiLink> ou contactez-nous :
            <MuiLink href="mailto:[email RGPD]"> [email RGPD]</MuiLink>.
        </Paragraph>
        </LegalLayout>
        <Footer/>
    </>
  );
}